<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card>
          <b-button variant="success" v-on:click="goTo('/admin/companies/add')"
            ><i class="fa fa-plus"></i> Add New Company</b-button
          >
        </b-card>
        <b-card>
          <div class="card-header">
            <i class="fa fa-align-justify"></i> Companies
          </div>
          <div v-if="!tableReady" class="table-loading-container">
            <img
              src="/img/wifi-loading.gif"
              alt="loading"
              class="loading-table"
            />
          </div>
          <div v-if="tableReady">
            <div v-if="!items.length">
              <b-alert show variant="warning">
                No Companies
              </b-alert>
            </div>
            <table class="table table-striped" v-if="items.length">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Landing Page</th>
                  <th>Date Added</th>
                  <th>Date Updated</th>
                  <th>Created By</th>
                  <th class="action-single"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item._id">
                  <td>
                    <router-link
                      :to="{ name: 'Update Company', params: { id: item._id } }"
                      >{{ item.name }}</router-link
                    >
                  </td>
                  <td>{{ item.landingPage | formatSlug }}</td>
                  <td>{{ item.dateAdded | formatDate }}</td>
                  <td>{{ item.dateUpdated | formatDate }}</td>
                  <td>
                    <div v-if="item.user">
                      {{ item.user.firstName }} {{ item.user.lastName }}
                    </div>
                  </td>
                  <td>
                    <button
                      class="btn btn-sm btn-danger"
                      @click="deleteItem(item)"
                      v-if="!item.isSuperAdmin"
                    >
                      <i class="fa fa-remove"></i> Delete
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-card>
      </b-col> </b-row
    ><!--/.row-->

    <b-modal
      title="Confirm Delete"
      class="modal-danger"
      v-model="deleteModal"
      @ok="confirmDelete()"
      ok-variant="danger"
    >
      <div><b>Are you sure you want to delete this company?</b></div>
      <div>{{ selectedItem.name }}</div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import common from "./../../../mixins/common";

export default {
  name: "companies",
  data() {
    return {
      selectedItem: {},
      items: [],
      deleteModal: false,
      tableReady: false
    };
  },
  mixins: [common],
  methods: {
    getItems: function() {
      let scope = this;
      scope.tableReady = false;
      axios
        .get(process.env.VUE_APP_API + "/company?populate=user&populate=user", {
          headers: {
            Authorization: "JWT " + scope.$localStorage.get("holly-fi-token")
          }
        })
        .then(function(response) {
          scope.items = response.data;
          scope.tableReady = true;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    deleteItem: function(selItem) {
      this.selectedItem = selItem;
      this.deleteModal = true;
    },
    confirmDelete: function() {
      this.deleteModal = false;
      let scope = this;
      axios
        .delete(
          process.env.VUE_APP_API + "/company/" + scope.selectedItem._id,
          {
            headers: {
              Authorization: "JWT " + scope.$localStorage.get("holly-fi-token")
            }
          }
        )
        .then(function(response) {
          scope.getItems();
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  },
  created() {
    this.getItems();
  }
};
</script>
